import { createEmitter } from "ts_utils";
import { FbAuth } from "../../services/firebase/FbAuth";
import { UserManager } from "../UserManager";
import * as uih from "./UiHelper";

export class EmailConfirmationView {
	
	private _ui:HTMLDivElement;
	
	private _instructionsDiv:HTMLDivElement;
	private _resendLink:HTMLAnchorElement;
	
	private _continueBtn:HTMLButtonElement;
	private _signoutLink:HTMLAnchorElement;
	
	public get event() { return this._emitter.event; }
	private _emitter = createEmitter<EmailConfirmationViewEvent>();
	
	constructor(ui:HTMLDivElement){
		this._ui = ui;
		this._init();
	}
	
	private _init():void {
		uih.hide(this._ui);
		
		this._instructionsDiv = this._ui.querySelector("#ecv-instructions");
		this._resendLink = this._ui.querySelector("#ecv-resendLink");
		
		this._continueBtn = this._ui.querySelector("#ecv-continueBtn");
		this._signoutLink = this._ui.querySelector("#ecv-signoutLink");
	}
	
	public activate():void {
		UserManager.get().hideLoadingOverlay();
		uih.show(this._ui);
		this._addListeners();
	}
	
	public deactivate():void {
		uih.hide(this._ui);
		this._removeListeners();
	}
	
	
	private _onResendLinkClick = async (e:MouseEvent):Promise<void> => {
		await this._sendEmailVerification();
	}
	
	private async _sendEmailVerification():Promise<void> {
		this._removeListeners();
		let userManager = UserManager.get();
		userManager.showLoadingOverlay();
		let success:boolean = await FbAuth.sendEmailVerification();
		this._addListeners();
		userManager.hideLoadingOverlay();
		// TODO: use a message div instead of _instructionsDiv
		// _instructionsDiv.innerText = success
		// 	? "The email has been resent to your address. After clicking to "
		// 		"confirm, return here and click Continue."
		// 	: "There was a problem sending the confirmation email.";
			
	}
	
	private _onContinueBtnClick = async (e:MouseEvent):Promise<void> => {
		await FbAuth.reloadUser();
		if (FbAuth.emailVerified()){
			this._emitter.emit(EmailConfirmationViewEvent.confirmed);
		}	
	}
	
	private _onSignoutLinkClick = (e:MouseEvent):void => {
		this._removeListeners();
		this._emitter.emit(EmailConfirmationViewEvent.signoutRequest);
	}
	
	private _addListeners():void {
		this._removeListeners();
		this._resendLink.addEventListener("click", this._onResendLinkClick);
		this._continueBtn.addEventListener("click", this._onContinueBtnClick);
		this._signoutLink.addEventListener("click", this._onSignoutLinkClick);
	}
	
	private _removeListeners():void {
		this._resendLink.removeEventListener("click", this._onResendLinkClick);
		this._continueBtn.removeEventListener("click",
			this._onContinueBtnClick);
		this._signoutLink.removeEventListener("click",
			this._onSignoutLinkClick);
	}
}

export enum EmailConfirmationViewEvent {
	confirmed,
	signoutRequest
}